/* eslint-disable complexity */
import {useMemo} from 'react';

import {CITE_FROM, URL_SOURCE} from '@/Constant';
import {
    getHeadingUuidByUrl,
    getBlockIdByUrl,
    getRightCommentIdByUrl,
    getDocIdByUrl,
    isDocShortUrl,
    isDocUrl,
} from '@/utils/urlUtils';
import {scrollIntoBlockAndTips, scrollIntoComment} from '@/utils/document/common';
import {addSourceToUrl} from '@/buried/utils';
import {openLinkProxy} from '@/hooks/queryViewController';

export const useHyperLinkConfig = (docId: string, noAnchor: boolean = false) => {
    return useMemo(() => {
        return {
            customProtocal: ['infoflow', 'baidu'],
            onOpen(url: string, editor?: any, options?: {from: string}) {
                const isDoc = isDocUrl(url) || isDocShortUrl(url);
                const {from} = options || {};
                const urlSource = from === CITE_FROM.content
                    ? URL_SOURCE.docContentMentionDoc : URL_SOURCE.underlineCommentMentionDoc;
                const openUrl = addSourceToUrl(url, isDoc, {source: urlSource});
                // 不锚定到目标块，直接新页面打开
                if (noAnchor) {
                    // 防止window.open打开的新窗口带有baidu Referer,一些网站拦截(比如西瓜视频)
                    openLinkProxy(openUrl, 'new_window', 'noreferrer');
                    return;
                }

                const blockId = getBlockIdByUrl(url);
                const headingUuid = getHeadingUuidByUrl(url);
                // 获取文档id
                const tokenDocId = getDocIdByUrl(url);
                // 判断是否为同一页面并且有锚点
                if ((blockId || headingUuid) && tokenDocId === docId) {
                    // 滚动锚点至视窗内
                    scrollIntoBlockAndTips({blockId, headingUuid});
                    return;
                }

                // 带划线评论id的链接滚动到评论处
                const commentId = getRightCommentIdByUrl(url);
                if (commentId && tokenDocId === docId) {
                    scrollIntoComment(commentId);
                    return;
                }
                // 防止window.open打开的新窗口带有baidu Referer,一些网站拦截(比如西瓜视频)
                openLinkProxy(openUrl, 'new_window', 'noreferrer');
            },
        };
    }, [docId, noAnchor]);
};
